import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {FilterHeaderService} from '../../services/filter-header.service';

@Component({
  selector: 'app-save-filters-dialog',
  templateUrl: './save-filters-dialog.component.html',
  styleUrls: ['./save-filters-dialog.component.css']
})
export class SaveFiltersDialogComponent implements OnInit {
  saveName: string;

  constructor(
    public dialogRef: MatDialogRef<SaveFiltersDialogComponent>,
    private filterHeaderService: FilterHeaderService
  ) { }

  ngOnInit() {
  }

  onSaveClicked() {
    this.filterHeaderService.saveFilters(this.saveName)
      .subscribe(result => {
        this.dialogRef.close(this.saveName);
      });
  }
}
